import { store } from "../stores/UserStore";

export default ( to, from, next ) => {
  // Check if user is authenticated
  if ( store.getters.user ) {
    next()
  } else {
    next( '/login' )
  }
}


// WEBPACK FOOTER //
// ./src/router/auth-guard.js